import React from "react";
import { createRoot } from "react-dom/client";
import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import reducers from "../src/store/reducers";
import logger from "redux-logger";
import App from "./App";

let middleware = [thunk];
if (process.env.REACT_APP_SERVER_ENV === "development") {
  middleware.push(logger);
}

const store = configureStore({
  reducer: reducers,
  middleware: middleware,
});

// const store = createStore(reducers, {}, applyMiddleware(...middleware));

const root = createRoot(document.getElementById("root"));
root.render(<App store={store} />);
